import Logo from "../assets//logo.png";
import { Link } from "react-router-dom";
import { MdEmail, MdLocationOn, MdPhone } from "react-icons/md";
import { FaTwitter, FaFacebookF, FaYoutube, FaInstagram } from "react-icons/fa";
import { MainContext } from "../utils/context/main-context";
import { useContext } from "react";

function Footer() {
  const { footerRef } = useContext(MainContext);
  return (
    <footer
      ref={footerRef}
      id="footer"
      className="relative pt-8 bg-cmathsDark border-t border-gray-900"
    >
      <div className="relative mb-4">
        <div className="context">
          <div className="grid  grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-y-6 md:gap-x-10">
            <div className="ft-item col-span-2 lg:col-span-1">
              <div className="relative w-44 mx-auto">
                <img src={Logo} alt="Footer Logo" />
              </div>
              <p className="text-xs text-center text-gray-400">
                අද්විතීය ප්‍රථිඵල වාර්තා කරමින්, සහජ දක්ෂයින් අතිවිශිෂ්ටයින් ලෙස
                ඉදිරියට යෑමට, ගැඹුරු විෂය කරුණු පවා ඉතාමත් සරලව හා තර්කානුකූලව,
                මනසට කා වදින ලෙස ඉගෙන ගැනීමට එන්න අප හා එක්වන්න.
              </p>
            </div>
            <div className="ft-item">
              <div className="ft-title">
                <h6>Useful Links</h6>
              </div>
              <div className="ft-info">
                <ul>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/courses">Subjects</Link>
                  </li>
                  <li>
                    <Link to="/institutes">Institutes</Link>
                  </li>
                  <li>
                    <a href="https://support.sailingpen.lk">Support</a>
                  </li>

                  <li>
                    <Link to="/refund-policy">Refund Policy</Link>
                  </li>
                  <li>
                    <Link to="/account-deletion">Account Deletion</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="ft-item">
              <div className="ft-title">
                <h6>Social Media</h6>
              </div>
              <div className="ft-info">
                <ul>
                  <li>
                    <a href="mailto:sailingpenpvtltd@gmail.com">
                      <MdEmail className="w-5 h-5" />
                      <span>Email</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://twitter.com/combinedmathslk"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaTwitter className="w-5 h-5" />
                      <span>X</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://web.facebook.com/combinedmaths.lk"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaFacebookF className="w-5 h-5" />
                      <span>Facebook</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/@CombinedMathsRuwanDarshana"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaYoutube className="w-5 h-5" />
                      <span>Youtube</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/combinedmaths_ruwandarshana"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaInstagram className="w-5 h-5" />
                      <span>Instagram</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="ft-item col-span-2 md:col-span-1">
              <div className="ft-title">
                <h6>Contact Info</h6>
              </div>
              <div className="ft-info">
                <ul>
                  <li>
                    <a
                      href="https://www.google.com/maps/place/Sailing+Pen+Academy+of+Higher+Education/@6.8640699,79.8945478,18z/data=!3m1!4b1!4m6!3m5!1s0x3ae25bf8011c1a63:0x4e030a54702c0f31!8m2!3d6.8640672!4d79.8958353!16s%2Fg%2F11j22s7n1_?authuser=0&entry=ttu&g_ep=EgoyMDI2MDUyMC4wIKXMDSoASAFQAw%3D%3D"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <MdLocationOn className="w-5 h-5" />{" "}
                      <span>24, Papiliyana Rd, Gangodavila, Nugegoda</span>
                    </a>
                  </li>
                  <li>
                    <a href="tel:+94706818110">
                      <MdPhone className="w-5 h-5" />
                      <span>070 681 81 10</span>
                    </a>
                  </li>
                  <li>
                    <a href="tel:+94706818111">
                      <MdPhone className="w-5 h-5" />
                      <span>070 681 81 11</span>
                    </a>
                  </li>
                  <li>
                    <a href="tel:+94706818112">
                      <MdPhone className="w-5 h-5" />
                      <span>070 681 81 12</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="relative py-4 bg-cmathsDark border-t border-gray-900">
        <div className="context">
          <div className="relative flex flex-wrap justify-center md:justify-between space-y-2">
            <div className="flex-initial">
              <p className="text-sm font-medium text-white">
                Copyright © {new Date().getFullYear()}{" "}
                <a
                  href="/"
                  className="bg-primary-gradient bg-clip-text text-transparent"
                >
                  Combinedmaths.lk
                </a>{" "}
                All rights reserved.
              </p>
            </div>
            <div className="flex-initial">
              <p className="text-sm text-white">
                <Link
                  to="/privacy-policy"
                  className="text-gray-400 hover:text-cmathsPrimary transition-all duration-300 ease-in-out"
                >
                  Privacy Policy
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
